import { ActionTree } from 'vuex';
import RootState from './RootState';
import TMAlert from '@/tools/models/TMAlert';
import User from '@/tools/models/User';
import ApiRequest from '@/tools/ApiRequest';

const actions: ActionTree<RootState, RootState> = {
  setAlert(context, alert: TMAlert): void {
    context.commit('setAlert', alert);
  },
  async getUserFromApi(context): Promise<any> {
    await ApiRequest.getUser().then((response) => {
      context.commit('setUser', response.data);
    });
  },
  unsetUser(context): void {
    context.commit('setUser', new User());
  },
  subLuckySpins(context): void {
    context.commit('subLuckySpins');
  },
  setInitialMessageShown(context, value: boolean): void {
    context.commit('setInitialMessageShown', value);
  },
};

export default actions;
